import React from 'react'
import { PromotionsTableNew } from '../components/promotions/PromotionsTableNew'

export const Promotions = ({}) => {
    return <PromotionsTableNew />
}
